{
  "basicTerms": {
    "selectedOfTotal": "{selected}/{total} 件選択中",
    "search": "検索",
    "summary": "概要",
    "insights": "インサイト",
    "help": "ヘルプ",
    "expand": "展開",
    "collapse": "折りたたむ",
    "menu": "メニュー",
    "account": "アカウント",
    "logout": "ログアウト",
    "signIn": "サインイン",
    "days": "日 | 日",
    "phone": "電話",
    "subscribers": "通知受信者 | 通知受信者",
    "favorites": "お気に入り | お気に入り",
    "others": "その他 | その他",
    "yes": "はい",
    "no": "いいえ",
    "locations": "拠点 | 拠点",
    "active": "有効",
    "inactive": "無効",
    "all": "すべて",
    "view": "表示",
    "language": "言語",
    "required": "必須",
    "timezone": "タイムゾーン",
    "new": "新規",
    "open": "開く",
    "close": "閉じる",
    "closed": "閉鎖",
    "occupied": "使用中",
    "reserved": "確保済み",
    "enabled": "有効",
    "disabled": "無効",
    "enable": "有効にする",
    "disable": "無効にする",
    "print": "印刷",
    "download": "ダウンロード",
    "zoomIn": "拡大",
    "zoomOut": "縮小",
    "previous": "前へ",
    "next": "次へ",
    "version": "バージョン",
    "setup": "設定",
    "caution": "注意",
    "notes": "メモ | メモ",
    "add": "追加",
    "remove": "削除",
    "duration": "所要時間",
    "link": "リンク",
    "unlink": "リンク解除",
    "to": "～",
    "success": "成功",
    "error": "エラー",
    "info": "情報",
    "warning": "警告",
    "time": "時刻",
    "saved": "保存しました",
    "forms": "フォーム | フォーム",
    "is": "が",
    "only": "のみ",
    "saving": "保存しています",
    "text": "テキスト",
    "zip": "zip",
    "spreadsheet": "スプレッドシート",
    "image": "画像",
    "cloning": "複製しています",
    "clone": "複製",
    "added": "追加済み",
    "removed": "削除済み",
    "planned": "予定あり",
    "unplanned": "予定外",
    "checkedIn": "チェックイン済み",
    "checkedOut": "チェックアウト済み",
    "more": "その他",
    "okay": "OK",
    "reschedule": "日時を変更",
    "results": "結果 | 結果",
    "none": "なし",
    "pages": "ページ | ページ",
    "pageOfTotal": "{current} / {total} ページ",
    "of": "/",
    "default": "デフォルト",
    "soon": "近日公開",
    "grid": "グリッド",
    "list": "リスト",
    "booked": "予約済み",
    "arrivals": "到着 | 到着",
    "early": "早着",
    "late": "遅延",
    "onTime": "定刻",
    "area": "エリア | エリア",
    "spot": "スポット",
    "single": "単一",
    "multiple": "複数",
    "filter": "フィルター",
    "board": "ボード",
    "at": "場所：",
    "from": "移動元：",
    "recent": "最近",
    "delivered": "配信済み",
    "sent": "送信済み",
    "failed": "失敗",
    "create": "作成",
    "tasks": "タスク | タスク",
    "emails": "メール | メール",
    "passwords": "パスワード | パスワード",
    "limits": "上限",
    "assignee": "担当者",
    "comment": "コメント",
    "issue": "問題",
    "urgent": "緊急",
    "retry": "再試行",
    "custom": "カスタム",
    "na": "該当なし"
  },
  "phrases": {
    "updateEmail": "メールを更新",
    "copyToClipboard": "クリップボードにコピー",
    "copiedToClipboard": "クリップボードにコピーしました",
    "warehouseAddress": "倉庫の住所",
    "cloneSchedule": "スケジュールを複製",
    "open24Hours": "24 時間営業",
    "featureEnabled": "機能が有効です",
    "featureDisabled": "機能が無効です",
    "learnMore": "詳細はこちら",
    "minuteLabel": "{minutes} 分",
    "minuteLabelFull": "{minutes} 分",
    "thisActionCannotBeUndone": "この操作は元に戻せません",
    "areYouSure": "よろしいですか？",
    "unknownUser": "不明なユーザー",
    "leaveWithoutSaving": "保存せずに移動",
    "learnHowItWorks": "仕組みを見る",
    "allFields": "すべての項目",
    "selectColumns": "列を選択",
    "selectedColumns": "選択した列",
    "addFiles": "ファイルを追加 | ファイルを追加",
    "tasks": "タスクなし | {count} 件のタスク | {count} 件のタスク",
    "driversSelfCheckin": "ドライバーのセルフチェックイン",
    "addReferenceNumber": "参照番号を追加",
    "myAccount": "マイアカウント"
  },
  "messages": {
    "theConfirmationFieldDoesNotSupportPasting": "確認用の入力欄には貼り付けできません",
    "youMayHaveUnsavedChangesAreYouSureYouWantToLeaveThisPage": "保存されていない変更がある可能性があります。このページから移動してもよろしいですか？",
    "browserDoesNotSupportCopyFunction": "お使いのブラウザはコピー機能に対応していません",
    "permissionToAccessClipboardWasDeniedToEnableAccessUpdateYourBrowserSettings": "クリップボードへのアクセスが拒否されました。アクセスを許可するには、ブラウザの設定を変更してください。",
    "alternativelyYouCanManuallyCopy": "または、手動でコピーすることもできます",
    "areYouSureYouWantToLeaveYouMayHaveUnsavedChanges": "移動してもよろしいですか？保存されていない変更がある可能性があります。",
    "noResultsFound": "結果が見つかりません",
    "maximumOfReferenceNumbersAllowedCountRemoved": "参照番号は最大 {maxItems} 件までです。{removedCount} 件を削除しました"
  },
  "fileFormats": {
    "jpeg": "jpeg",
    "jpg": "jpg",
    "png": "png",
    "webp": "webp",
    "pdf": "pdf"
  },
  "specialtyTerms": {
    "opendock": "Opendock",
    "warehouses": "倉庫 | 倉庫",
    "carrierContacts": "運送会社の担当者 | 運送会社の担当者",
    "loadTypes": "荷物の種類 | 荷物の種類",
    "docks": "ドック | ドック",
    "appointments": "予約 | 予約",
    "users": "ユーザー | ユーザー",
    "organizations": "組織 | 組織",
    "orgs": "組織 | 組織",
    "companies": "会社 | 会社",
    "referenceNumber": "参照番号",
    "refNumber": "参照番号",
    "status": "ステータス",
    "orgLoadTypes": "組織の荷物の種類",
    "schedulingPortal": "スケジューリングポータル",
    "customFields": "カスタム項目 | カスタム項目",
    "interval": "間隔",
    "drivers": "ドライバー | ドライバー",
    "carriers": "運送会社 | 運送会社",
    "tags": "タグ | タグ",
    "yardManagement": "ヤード管理",
    "carrier": "運送会社 | 運送会社",
    "assets": "アセット | アセット",
    "tvMode": "TV モード",
    "gridView": "グリッド表示",
    "listView": "リスト表示",
    "gateManagement": "ゲート管理",
    "selfCheckIn": "セルフチェックイン",
    "gateFeed": "ゲートフィード"
  },
  "appointmentStatuses": {
    "NoShow": "不着",
    "Cancelled": "キャンセル済み",
    "Requested": "リクエスト済み",
    "Scheduled": "予約済み",
    "Arrived": "到着済み",
    "InProgress": "作業中",
    "Completed": "完了",
    "Reserves": "仮押さえ"
  },
  "appointmentTypes": {
    "standard": "通常",
    "reserved": "仮押さえ済み",
    "reserve": "仮押さえ"
  },
  "appointmentCreatorTypes": {
    "warehouseUser": "倉庫ユーザー",
    "carrier": "運送会社"
  },
  "roles": {
    "base": "ベーシック",
    "carrier": "運送会社",
    "carrierAdmin": "運送会社管理者",
    "spectator": "閲覧者",
    "attendant": "アテンダント",
    "operator": "オペレーター",
    "admin": "管理者",
    "owner": "オーナー",
    "internal": "内部",
    "god": "God"
  },
  "weekdays": {
    "sunday": "日曜日",
    "monday": "月曜日",
    "tuesday": "火曜日",
    "wednesday": "水曜日",
    "thursday": "木曜日",
    "friday": "金曜日",
    "saturday": "土曜日"
  },
  "weekdaysAbbr": {
    "sun": "日",
    "mon": "月",
    "tue": "火",
    "wed": "水",
    "thu": "木",
    "fri": "金",
    "sat": "土"
  },
  "buttons": {
    "nevermind": "やめる",
    "select": "選択",
    "confirm": "確認",
    "next": "次へ",
    "previous": "前へ",
    "create": "作成",
    "edit": "編集",
    "save": "保存",
    "send": "送信",
    "yesDelete": "はい、削除します",
    "skipCreation": "作成をスキップ",
    "cancel": "キャンセル",
    "export": "エクスポート",
    "saveChanges": "変更を保存",
    "exportData": "データをエクスポート",
    "resetToDefault": "デフォルトに戻す"
  },
  "tooltips": {
    "notAvailable": "利用できません",
    "notAvailableForUserRole": "お使いのユーザーロールでは利用できません。"
  },
  "errors": {
    "unkownError": "不明なエラーが発生しました。",
    "thisFieldIsRequired": "この項目は必須です",
    "passwordDoesNotMeetRequirements": "パスワードが要件を満たしていません",
    "emailMustBeValid": "有効なメールアドレスを入力してください",
    "pleaseEnterAValidPhoneNumber": "有効な電話番号を入力してください",
    "pleaseEnterAValidUrl": "有効な URL を入力してください",
    "invalidHour": "時間が無効です",
    "invalidMinute": "分が無効です",
    "pleaseSelectAmOrPm": "AM または PM を選択してください",
    "pleaseEnterACompleteDateAndTime": "日付と時刻をすべて入力してください",
    "mustBeANumber": "数値を入力してください",
    "mustBeAPositiveInteger": "正の整数を入力してください",
    "mustBeAWholeNumber": "整数を入力してください",
    "isNotAValidNumber": "は有効な数値ではありません",
    "isNotValid": "は無効です",
    "invalidUuid": "UUID が無効です",
    "dateMustNotBeInThePast": "過去の日付は指定できません",
    "mustBeWithin24HoursOfStartTime": "は開始時刻から 24 時間以内である必要があります",
    "pleaseSelectAtLeast": "{itemName}を {requiredCount} 個以上選択してください | {itemName}を {requiredCount} 個以上選択してください",
    "cannotSelectMoreThan": "{itemName}は {limit} 個までしか選択できません | {itemName}は {limit} 個までしか選択できません",
    "fieldMustEqual": "値は {value} である必要があります",
    "mustBeXCharacters": "{length} 文字で入力してください | {length} 文字で入力してください",
    "mustBeAtLeastXCharacters": "{min} 文字以上で入力してください | {min} 文字以上で入力してください",
    "mustBeAtMostXCharacters": "{max} 文字以内で入力してください | {max} 文字以内で入力してください",
    "mustBeBetweenXAndYCharactersLong": "{min}～{max} 文字で入力してください",
    "mustBeNumberBetweenXAndY": "{min}～{max} の数値を入力してください",
    "mustBeNumberGreaterThan": "{min} 以上の数値を入力してください",
    "mustBeNumberLessThan": "{max} 未満の数値を入力してください",
    "mustHaveAtLeast8Characters": "8 文字以上である必要があります",
    "mustContainUpperCaseAndLowerCase": "大文字と小文字を含める必要があります",
    "mustContainAtLeastOneLetter": "英字を 1 文字以上含める必要があります",
    "mustContainAtLeastOneSpecialCharacter": "記号を 1 文字以上含める必要があります",
    "mustContainAtLeastOneNumber": "数字を 1 文字以上含める必要があります",
    "atLeastOneReferenceNumberIsRequired": "{refNumberDisplayName}を 1 つ以上入力してください",
    "mustBeAValidNumber": "有効な数値を入力してください"
  },
  "warehouseAmenities": {
    "lumperServices": "荷役代行サービス（ランパー）",
    "overnightParking": "夜間駐車場",
    "driversRestroom": "ドライバー用トイレ",
    "freeWiFi": "無料 Wi-Fi"
  },
  "warehousePPERequirements": {
    "safetyBoots": "安全靴",
    "safetyGlasses": "保護メガネ",
    "gloves": "手袋",
    "hardHat": "ヘルメット",
    "faceMask": "マスク",
    "noSmoking": "禁煙",
    "longPants": "長ズボン",
    "longSleeves": "長袖",
    "highVisibilityVest": "高視認性ベスト",
    "hairAndBeardNet": "ヘアネット・ひげネット"
  },
  "auditLog": {
    "header": "監査ログ",
    "viewAuditLog": "監査ログを表示",
    "noAuditLogEvents": "監査ログのイベントはありません",
    "printedOn": "印刷日: {date}",
    "viewDetails": "詳細を表示",
    "snapshot": {
      "schedule": "スケジュール",
      "eta": "到着予定",
      "emailSubscribers": "メール購読者",
      "customFields": "カスタムフィールド",
      "statusTimes": "ステータス時刻"
    },
    "timelineForAllUpdatesMadeToThis": "すべての更新履歴のタイムライン：",
    "hasTheWords": "含まれる語句",
    "eventsFromDate": "イベントの開始日",
    "searchEvents": "イベントを検索",
    "by": "実行者：",
    "appointmentUpdatesTimeline": "予約の更新履歴：",
    "moreUpdates": "他 {count} 件の更新",
    "emailSubscribersUpdated": "メール通知の受信者を更新",
    "detailsUpdated": "詳細を更新",
    "recurrenceCreated": "繰り返しを作成",
    "recurrenceDeleted": "繰り返しを削除",
    "rescheduled": "{label}の日時を変更",
    "etaUpdated": "到着予定時刻を更新",
    "emailNotifications": "メール通知",
    "carrierContactUpdated": "運送会社の担当者を更新",
    "reserveTransferred": "仮押さえを移行",
    "tagsUpdated": "タグを更新",
    "scheduled": "{label}を予約",
    "statusUpdated": "ステータスを更新",
    "timeUpdated": "{arrived}時刻を更新",
    "dwellTimeUpdated": "滞在時間を更新",
    "labelWithStatus": "{label} {status}",
    "arrivedLate": "{duration} 遅延",
    "everyXAtXUntilX": "毎週 {weekDays} {'@'} {endTime}（{endDate} まで）",
    "opendockTeam": "Opendock チーム",
    "unknownUser": "不明なユーザー",
    "deleted": "削除済み",
    "hasBeenCleared": "がクリアされました",
    "actionUpdated": "更新",
    "actionCreated": "作成",
    "actionDeleted": "削除",
    "noAction": "操作なし",
    "emptyValue": "空の値"
  },
  "timeline": {
    "createdTheTask": "がタスクを作成しました",
    "startedTheTask": "がタスクを開始しました",
    "blockedTheTask": "がタスクをブロックしました",
    "unblockedTheTask": "がタスクのブロックを解除しました",
    "completedTheTask": "がタスクを完了しました",
    "cancelledTheTask": "がタスクをキャンセルしました",
    "cancelledTheReserve": "が確保をキャンセルしました",
    "cancelledTheReservationForSpot": "がこのタスクの {areaName} - {spotCode} の確保をキャンセルしました",
    "reservedSpotForThisTask": "がこのタスク用に {areaName} - {spotCode} を確保しました",
    "reservedTheSpot": "がスポットを確保しました",
    "reason": "理由：{reason}",
    "addedA": "が追加しました：",
    "reportedAn": "が報告しました：",
    "clearedThe": "がクリアしました：",
    "flaggedTheTask": "がタスクにフラグを付けました",
    "flaggedTheTaskAs": "がタスクにフラグを付けました：",
    "unflaggedTheTask": "がタスクのフラグを解除しました",
    "unflaggedTheTaskAs": "がタスクのフラグを解除しました：",
    "updatedTheTask": "がタスクを更新しました",
    "removedTask": "がタスクを削除しました",
    "attachments": "添付ファイル",
    "confirmedTheLocation": "が場所を確認しました",
    "reportedAsMissing": "が所在不明として報告しました",
    "noActivityYet": "まだアクティビティはありません",
    "noAssignee": "担当者なし",
    "failedToFetchYardTaskTimeline": "ヤードタスクのタイムラインを取得できませんでした",
    "failedToCreateComment": "コメントを作成できませんでした"
  },
  "yardSpotStatusDialog": {
    "headers": {
      "actionThisSpot": "このスポットを{action}しますか？"
    },
    "dropDownItems": {
      "cleaning": "清掃中",
      "underMaintenance": "メンテナンス中",
      "blockedByEquipment": "機材によるふさがり",
      "safetyInspection": "安全点検",
      "routineInspection": "定期点検",
      "reserved": "確保済み",
      "repairsNeeded": "要修理",
      "damage": "損傷"
    },
    "labels": {
      "reason": "理由",
      "additionalNotes": "補足メモ"
    },
    "placeholders": {
      "selectAReason": "理由を選択",
      "enterAdditionalNotes": "補足メモを入力"
    },
    "messages": {
      "thisSpotWillRemainUnavailable": "このスポットは、再び開放に設定されるまでアセットを割り当てられません。",
      "thisDoorWillBeSetAsOpen": "この扉は開放に設定され、再びアセットを割り当てられるようになります。",
      "assetInTransitClosingWillBlockMove": "アセット {assetCode} は現在このスポットへ移動中です。閉鎖すると移動を完了できなくなります。"
    }
  },
  "tasks": {
    "presenter": {
      "unassigned": "未割り当て",
      "noDueDate": "期限なし",
      "fromAnySpot": "任意のスポットから",
      "toAnySpot": "任意のスポットへ",
      "anyAsset": "任意のアセット",
      "types": {
        "move": "移動"
      },
      "status": {
        "toDo": "未着手",
        "inProgress": "作業中",
        "completed": "完了",
        "canceled": "キャンセル済み"
      },
      "issue": "問題",
      "relatedEntity": {
        "spotArea": "エリア",
        "spot": "スポット",
        "asset": "アセット"
      }
    }
  },
  "readyForPickupNotificationDialog": {
    "title": "引き取り準備完了の通知",
    "messages": {
      "body": "アセット {assetContainerCode} が {warehouseName} で引き取り可能になったことを、以下の連絡先にメールで通知します。",
      "notificationSent": "通知を送信しました。",
      "notificationFailed": "通知を送信できませんでした。もう一度お試しください。"
    },
    "labels": {
      "notifyTheseContacts": "通知する連絡先：",
      "suggestedContacts": "おすすめの連絡先："
    },
    "buttons": {
      "skipNotification": "通知をスキップ"
    }
  },
  "chipList": {
    "keys": {
      "enter": "enter",
      "tab": "tab"
    },
    "messages": {
      "pressEnterOrTabToActionEntity": "{enterKey} または {tabKey} を押して {entity} を{action}",
      "pressEnterOrTabToAddEmail": "{enterKey} または {tabKey} を押してメールアドレスを追加"
    },
    "placeholders": {
      "emailSubscribers": "メール購読者"
    }
  }
}
